import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { joinTrip } from '../../shared/api/invite'
import { Spinner } from '../../shared/components/Spinner'

export function JoinTrip() {
  const { token } = useParams<{ token: string }>()
  const navigate = useNavigate()
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    if (!token) { setError('Invalid invite link'); return }
    joinTrip(token)
      .then((result) => navigate(`/trips/${result.trip_id}`, { replace: true }))
      .catch((err: unknown) => setError(err instanceof Error ? err.message : 'Invalid or expired invite link'))
  }, [token, navigate])

  if (error) {
    return (
      <div className="flex min-h-[60vh] flex-col items-center justify-center gap-4 text-center">
        <p className="text-lg font-medium text-st-text">Invite link error</p>
        <p className="max-w-sm text-sm text-st-muted">{error}</p>
        <a href="/" className="text-sm text-st-primary underline">Go to dashboard</a>
      </div>
    )
  }

  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-3">
      <Spinner />
      <p className="text-sm text-st-muted">Joining trip…</p>
    </div>
  )
}
